/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Numbers_TitleInputs */

const en_about_numbers_title = /** @type {(inputs: About_Numbers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema in Numbers`)
};

const de_about_numbers_title = /** @type {(inputs: About_Numbers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema in Zahlen`)
};

const fr_about_numbers_title = /** @type {(inputs: About_Numbers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema in Numbers`)
};

const es_about_numbers_title = /** @type {(inputs: About_Numbers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema in Numbers`)
};

const it_about_numbers_title = /** @type {(inputs: About_Numbers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema in Numbers`)
};

const nl_about_numbers_title = /** @type {(inputs: About_Numbers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema in Numbers`)
};

const pl_about_numbers_title = /** @type {(inputs: About_Numbers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema in Numbers`)
};

const fi_about_numbers_title = /** @type {(inputs: About_Numbers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema in Numbers`)
};

const da_about_numbers_title = /** @type {(inputs: About_Numbers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema in Numbers`)
};

const sv_about_numbers_title = /** @type {(inputs: About_Numbers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema in Numbers`)
};

/**
* | output |
* | --- |
* | "Alchema in Numbers" |
*
* @param {About_Numbers_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_numbers_title = /** @type {((inputs?: About_Numbers_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Numbers_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_numbers_title(inputs)
	if (locale === "fr") return fr_about_numbers_title(inputs)
	if (locale === "es") return es_about_numbers_title(inputs)
	if (locale === "it") return it_about_numbers_title(inputs)
	if (locale === "nl") return nl_about_numbers_title(inputs)
	if (locale === "pl") return pl_about_numbers_title(inputs)
	if (locale === "fi") return fi_about_numbers_title(inputs)
	if (locale === "da") return da_about_numbers_title(inputs)
	if (locale === "sv") return sv_about_numbers_title(inputs)
	return en_about_numbers_title(inputs)
});